<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>备忘录</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content_top">
        <router-link :to="{path:'/daily/remind/save'}">
          <el-button type="primary" size="small" icon="el-icon-circle-plus-outline">添加</el-button>
        </router-link>
      </div>
      <div class="content">
        <el-table border :data="reminds_list">
          <el-table-column prop="title" label="标题" align="center"></el-table-column>
          <el-table-column prop="content" label="内容" align="center"></el-table-column>
          <el-table-column prop="plan" label="调度计划" align="center"></el-table-column>
          <el-table-column label="是否调度" align="center">
            <template slot-scope="scope" v-if="scope.row && scope.row.id">
              <el-tag :type="scope.row && scope.row.status == 1 ? 'success' : 'info'">
                {{ scope.row && scope.row.status == 1 ? '是' : '否' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="220">
            <template slot-scope="scope" v-if="scope.row && scope.row.id">
              <router-link :to="{ path : '/daily/remind/save', query:{ id: scope.row.id}}">
                <el-button type="text" icon="el-icon-edit">修改</el-button>
              </router-link>

              <el-button
                v-if="scope.row.is_del == 0"
                class="success"
                type="text"
                @click="deleteRemind(scope.row.id)"
                icon="el-icon-setting"
              >删除</el-button>

              <el-button :class="scope.row.status == 1 ? 'danger' : 'primary'" type="text" @click="allowRemind(scope.row)" icon="el-icon-setting">
                {{scope.row.status == 1 ? '禁用' : '启用'}}
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          background
          :page-sizes="[pageSize]"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 15,
      reminds_list: []
    };
  },
  methods: {
    currentChange(page) {
      this.page = page;
      this.getReminds();
    },
    deleteRemind(id) {
      let _id = id;
      this.$confirm("是否删除该条备忘录吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        var loading = this.$loading({
          lock: true,
          text: '保存中...',
          spinner: 'el-icon-loading',
          background: 'hsla(0,0%,100%,.9)',
        });

        this.$ajax({
          url: "/daily/remind/delete",
          data:{
            id: _id,
          },
          type:"POST",
        }).then(res => {
          loading.close()
          this.$util.msg(res.msg, "success");
          setTimeout(() => {
            this.getReminds();
          }, 1200);
        });
      })
      .catch(() => {});
    },
    allowRemind(remind) {
      var loading = this.$loading({
        lock: true,
        text: '保存中...',
        spinner: 'el-icon-loading',
        background: 'hsla(0,0%,100%,.9)',
      });

      this.$ajax({
        url: "/daily/remind/ops",
        data:{
          id: remind.id,
          act: remind.status == 1 ? 'disable' : 'allow',
        },
        type:"POST",
      }).then(res => {
        loading.close()
        this.$util.msg(res.msg, "success");
        setTimeout(() => {
          this.getReminds();
        }, 1200);
      });
    },
    getReminds() {
      this.$ajax({
        url: "/daily/remind/index",
        data:{
          page: this.page,
          limit: this.pageSize
        }
      }).then(data => {
        this.reminds_list = data.data.data;
        this.total = data.data.total;
      });
    },
  },
  mounted() {
    this.getReminds();
  },
};
</script>